<div class="full-page-container">
  <div class="d-none d-lg-block">
    <fgb-banner [title]="'points.management.page.title' | translate"></fgb-banner>
  </div>

  <fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/'"></fgb-page-header>

  <fgb-account-nav></fgb-account-nav>

  <div class="container">
    <h4 class="instructions-info-title font-size-18">{{ 'point.transfer.instructions.info.title' | translate }}</h4>
    <div class="font-size-14" [innerHTML]="'point.transfer.instructions.info' | translate | markdownTranslate"></div>
    <fgb-points-transfer> </fgb-points-transfer>
  </div>
</div>
